import { render, staticRenderFns } from "./backgroundScript.vue?vue&type=template&id=ff9ef7e2"
import script from "./backgroundScript.vue?vue&type=script&lang=js"
export * from "./backgroundScript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports